const UserThumbnail = ({src,radius=24})=>(
	Boolean(src)&&
	<img 
		src={src}
		style={{
			borderRadius:`${radius*2}px`,
			marginRight:'4px',
			width:`${radius}px`,
			height:`${radius}px`,
			objectFit:'cover',
			border:'1px solid #ccc'
		}}
	/>
)

export default UserThumbnail